import React, { useEffect, useState } from "react";

import { BsWhatsapp } from "react-icons/bs";

import { Link } from "react-router-dom";
import { Navigate } from "react-router-dom";

import Sigecap from "../../assets/logo_sigecap_inline.png";

import "../Home/styles.css";

import { api } from "../../services/api";
import Rodape from "../../components/Footer/rodape";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { DashLayoutGrid } from "../../components/DashLayoutGrid";
import { DashLayout } from "../../components/DashLayout";

import { SlideCourse } from "../../components/BannerCourse";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";

import Perfil from "../../assets/man.png";

import CourseDisOn from "../../images/painel/cursos.jpg";
import PontosImg from "../../images/painel/pontos.jpg";
import Certificate from "../../images/painel/performace.jpg";
import AutorizationCourse from "../../images/painel/aceita.png";

export const Home = () => {
  const _data = JSON.parse(sessionStorage.getItem("@Auth:data"));
  const _user = JSON.parse(sessionStorage.getItem("@Auth:user"));

  const [courseDisponiveis, setCourseDisponiveis] = useState([]);
  const [inscricaoCourse, setInscricaoCourse] = useState([]);
  const [list, setList] = useState([]);
  const [pontAno, setPontAno] = useState([]);
  const [aviso, setAviso] = useState([]);
  
  const courseDisp = async () => {
    try {
      const httpOptions = {
        headers: {
          Accept: "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
        },
      };
      const res = await api.get("/curso/disponiveis", httpOptions);
      setCourseDisponiveis(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    courseDisp();
  }, [setCourseDisponiveis]);

  const inscriCourse = async () => {
    try {
      const httpOptions = {
        headers: {
          "Content-Type": "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
        },
      };

      const res = await api.get("/inscricao/listar", httpOptions);
      setInscricaoCourse(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    inscriCourse();
  }, [setInscricaoCourse]);

  const courseList = async () => {
    try {
      const httpOptions = {
        headers: {
          "Content-Type": "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
        },
      };
      const res = await api.get("/curso/lista", httpOptions);
      setList(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    courseList();
  }, [setList]);

  const PontAno = async () => {
    try {
      const httpOptions = {
        headers: {
          "Content-Type": "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
        },
      };
      const res = await api.get("/pontuacao/ano", httpOptions);
      setPontAno(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    PontAno();
    return;
  }, [setPontAno]);

  const Aviso = async () => {
    try {
      const httpOptions = {
        headers: {
          "Content-Type": "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
        },
      };
      const res = await api.get("/avisos", httpOptions);
      setAviso(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    Aviso();
    return;
  }, [setAviso]);

  function refreshPage() {
    setTimeout(() => {
      window.location.reload(false);
    }, 200);
  }
  const singOut = () => {
    sessionStorage.clear("@Auth:token");
    location.href = 'https://sesat1.sefaz.pb.gov.br/esat/sigecap/';
    refreshPage();
  };

  return (
    <>
      <Header />
      <Menu />
      <DashLayout>
        <h3 className="btn text-white m-0 text-justify">
          <b>
            <a
              className="whatsapp-link"
              href="https://wa.me/5583993769417"
              target="_blank"
            >
              <BsWhatsapp
                style={{
                  display: "inline",
                  marginTop: "4px",
                  marginLeft: "2px",
                }}
              />
            </a>
          </b>
        </h3>
        <button className="button login-form-btn-sair" onClick={singOut}>
          Sair
        </button>
        <br />
        <img src={Sigecap} alt="Dash" width="150px" />
        <br />
        <h1 className="home-title-dash">
          <p
            className="p-dash"
            style={{
              fontSize: "15px",
              alignContent: "center",
              color: "#eeeeee",
            }}
          >
            {_user}
          </p>
          <p className="p-dash" style={{ fontSize: "15px" }}>
            {_data.email}
          </p>
          <br />
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {aviso.map((item, i) => {
                return (
                  <tr key={i}>
                    <Image
                      src={Perfil}
                      roundedCircle
                      width="50px"
                      style={{ display: "flex" }}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "18px",
                        marginTop: "10px",
                      }}
                    >
                      {item.username}
                    </p>
                    <p style={{ color: "#cccc", fontSize: "15px" }}>
                      {item.mensagem}
                    </p>
                    <p style={{ color: "#ccc", fontSize: "13px" }}>
                      {new Date(item.timeAdd.date)
                        .toLocaleString()
                        .substr(0, 10)}{" "}
                      às{" "}
                      {new Date(item.timeAdd.date).toLocaleString("pt-br", {
                        timeStyle: "short",
                        hours12: false,
                        numberingSystem: "latn",
                      })}
                    </p>
                    <hr style={{ color: "#ccc", marginBottom: "25px" }} />
                  </tr>
                );
              })}
            </tbody>
          </table>
          <br />
          <h5 style={{ color: "#E6E7E3" }}>
            Acesso rápido <hr />
          </h5>

          <button type="submit" className="login-form-btn-dash-esat">
            <a
              href="https://sesat1.sefaz.pb.gov.br/esat/"
              style={{ textDecoration: "none" }}
              className="login-form-btn-dash-esat"
              target="_blank"
            >
              PORTAL ESAT - PORTAL CORPORATIVO DA ESCOLA DE ADMINISTRAÇÃO
              TRIBUTÁRIA - PB
            </a>
          </button>
          <button type="submit" className="login-form-btn-dash-esat">
            <a
              href="https://sesat1.sefaz.pb.gov.br/esatvirtual"
              style={{ textDecoration: "none" }}
              className="login-form-btn-dash-esat"
              target="_blank"
            >
              ESAT Virtual - CONHECIMENTO SEM LIMITES E SEM FRONTEIRAS
            </a>
          </button>
          <button type="submit" className="login-form-btn-dash-sefaz">
            <a
              href="https://www.sefaz.pb.gov.br/"
              style={{ textDecoration: "none" }}
              className="login-form-btn-dash-sefaz"
              target="_blank"
            >
              SEFAZ - PORTAL DA SEFAZ ESTADUAL DA PARAÍBA
            </a>
          </button>
          <button type="submit" className="login-form-btn-dash-fpat">
            <a
              href="https://sesat1.sefaz.pb.gov.br/fpat/"
              style={{ textDecoration: "none" }}
              className="login-form-btn-dash-fpat"
              target="_blank"
            >
              FPAT - FÓRUM PERMANENTE DE ADMINISTRADORES TRIBUTÁRIOS DA PARAÍBA
            </a>
          </button>
          <button type="submit" className="login-form-btn-dash-zimbra">
            <a
              href="https://mail.sefaz.pb.gov.br"
              style={{ textDecoration: "none" }}
              className="login-form-btn-dash-zimbra"
              target="_blank"
            >
              ZIMBRA - E-MAIL CORPORATIVO
            </a>
          </button>
          <button type="submit" className="login-form-btn-dash-atf">
            <a
              href="https://www4.sefaz.pb.gov.br/atf/"
              style={{ textDecoration: "none" }}
              className="login-form-btn-dash-atf"
              target="_blank"
            >
              ATF - ADMINISTRAÇÃO TRIBUTÁRIA E FINANCEIRA
            </a>
          </button>
          <button type="submit" className="login-form-btn-dash-gov">
            <a
              href="https://paraiba.pb.gov.br/"
              style={{ textDecoration: "none" }}
              className="login-form-btn-dash-gov"
              target="_blank"
            >
              Portal do Governo - PORTAL DO GOVERNO DO ESTADO DA PARAÍBA
            </a>
          </button>
        </h1>
      </DashLayout>
      <DashLayoutGrid>
        <br />        <h4 style={{ color: "white" }}>NOTÍCIAS</h4>
      <hr style={{ color: "#cccc" }} />
        <br />   
        <center>
          <div className="slides-on" >
          <SlideCourse />
          </div>
        </center>

        <hr style={{ color: "#cccc", fontSize: "2.5rem" }} />
        <br />
        <h4 style={{ color: "white" }}>PAINEL DE CONTROLE</h4>

        <br />

        <hr style={{ color: "#cccc", fontSize: "1rem" }} />
        <br />
        <br />
        <Row xs={1} md={3} className="g-4">
          <Col>
            <Card style={{ background: "#222222", color: "white" }}>
              <Card.Img
                variant="top"
                src={CourseDisOn}
                style={{ opacity: "0.6", height: "14rem" }}         
              />
              <Card.Body>
                <Card.Title>
                  CURSOS DISPONÍVEIS ({courseDisponiveis.length}){" "}
                </Card.Title>
                <Card.Text>grade de cursos ofertadas no momento.</Card.Text>
                <Link
                  className="bg-red-500 hover:bg-red-700 text-white md:text-[16px] font-bold py-2 px-4 rounded mt-3 text-decoration-none"
                  to="/esat/sigecap/curso/disponiveis"
                >
                  Ver mais
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card style={{ background: "#222222", color: "white" }}>
              <Card.Img
                variant="top"
                src={Certificate}
                style={{ opacity: "0.6", height: "14rem" }}                 
              />
              <Card.Body>
                <Card.Title>MEUS CURSOS ({list.length})</Card.Title>
                <Card.Text>Veja todos os cursos já realizado na ESAT</Card.Text>
                <Link
                  className="bg-red-500 hover:bg-red-700 text-white md:text-[16px] font-bold py-2 px-4 rounded mt-3 text-decoration-none"
                  to="/esat/sigecap/curso/meuscursos"
                >
                  Ver mais
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card style={{ background: "#222222", color: "white" }}>
              <Card.Img
                variant="top"
                src={PontosImg}
                style={{ opacity: "0.6", height: "14rem" }}               
              />
              <Card.Body>
                <Card.Title>
                  PONTOS EM {new Date().getFullYear()} - (
                  {Number(pontAno.total).toFixed(1)}){" "}
                </Card.Title>
                <Card.Text>Acompanhe seu progresso</Card.Text>
                <Link
                  className="bg-red-500 hover:bg-red-700 text-white md:text-[16px] font-bold py-2 px-4 rounded mt-3 text-decoration-none"
                  to="/esat/sigecap/performance/visualizar"
                >
                  Ver mais
                </Link>
              </Card.Body>
            </Card>
          </Col>
          {inscricaoCourse.length > 0 ? (
            <>
              {" "}
              <Col>
                <Card style={{ background: "#222222", color: "white" }}>
                  <Card.Img
                    variant="top"
                    src={AutorizationCourse}
                    style={{ opacity: "0.6", height: "14rem" }}     
                  />
                  <Card.Body>
                    <Card.Title>
                      Autorizar inscrição ({inscricaoCourse.length}){" "}
                    </Card.Title>
                    <Card.Text>
                      Grade de cursos com pessoas para liberar inscrição.
                    </Card.Text>
                    <Link
                      className="bg-red-500 hover:bg-red-700 text-white md:text-[16px] font-bold py-2 px-4 rounded mt-3 text-decoration-none"
                      to="/esat/sigecap/autorizar"
                    >
                      Ver mais
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
       
      </DashLayoutGrid>

      <Rodape />
    </>
  );
};
